import React from 'react'
import { Icon } from 'semantic-ui-react'

const Caret = ({ show }) =>
  show ? <Icon name="caret down" /> : <Icon name="caret right" />

export default Caret
